import * as ModalKeys from "Flocknote/GlobalComponents/Modal/contentKeys";

import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";
import clickElemOnExist from "Utilities/clickElemOnExist";
import externalNavigate from "Utilities/externalNavigate";

export const buttonFuncConfig = {
  goToExternalPage: (externalPage) => {
    externalNavigate(externalPage);
  },
  goToInternalPage: (internalPage) => {
    window.fnReactBus.goToUrl(internalPage);
  },
  goToInternalPageReload: (internalPage) => {
    window.location = internalPage;
  },
  openModal: (modalKey) => {
    window.fnReactBus.openModal(ModalKeys[modalKey], {});
  },
  openTextComposer: () => {
    window.fnReactBus.openTextComposer();
  },
  openLibrary: (module) => {
    window.fnReactBus.openLibrary();
    if (module) clickElemOnExist(`[data-csid="${module}"]`);
  },
  signupForPayments: () => {
    const signupForPaymentsCall = new FnrFetch3(`/people/startSubscription`);
    signupForPaymentsCall
      .post()
      .then(() => {
        var alertInfo = {
          title: "Success!",
          message:
            "You've upgraded to the <em>Flocknote Complete</em> package and unlocked a robust, integrated database that supercharges your member management and engagement!",
          subtext:
            "This upgrade is an additional $75 / month and can monitored in the billing section. Questions? Email help@flocknote.com.",
          type: "default",
          buttonAddClass: "green",
          buttonText: "Let's do this!",
          contextObj: {
            refreshFlocknote: () => window.location.reload(),
          },
          onConfirm: "refreshFlocknote",
          hideBackground: true,
        };
        window.fnReactBus.openLegacyAlert(alertInfo);
      })
      .catch((err) => {
        var alertInfo = {};
        if (err.error === "payment_method") {
          alertInfo = {
            title: "Missing Payment Method",
            message:
              "Whoops! It looks like we do not have a payment method on file for this network. You will need to add one before adding <em>Flocknote Complete</em>.",
            type: "default",
            buttonAddClass: "green",
            buttonText: "Add Payment Method",
            denyButton: "Cancel",
            contextObj: {
              handleMissingPaymentAlertConfirm: (alertObj) => {
                window.fnReactBus.goToUrl(
                  "billing/collectOneTimePaymentInfo?conv=1"
                );
                alertObj.closeAlert();
              },
              handleMissingPaymentAlertClose: () => {},
            },
            onConfirm: "handleMissingPaymentAlertConfirm",
            onClose: "handleMissingPaymentAlertClose",
            hideBackground: true,
          };
        } else {
          alertInfo = {
            title: "Something went wrong!",
            message:
              "Uh Oh! Looks like there was an issue trying to signup for your subscription. Please reach out to help@flocknote.com",
            type: "default",
            buttonAddClass: "green",
            buttonText: "Ok",
            hideBackground: true,
            contextObj: {
              handleConfirm: (alertObj) => {
                alertObj.closeAlert();
              },
            },
            onConfirm: "handleConfirm",
          };
        }
        window.fnReactBus.openLegacyAlert(alertInfo);
      });
  },
};
